{
  "blocks": [
    {
      "id": "checklist-at-clinic",
      "kind": "checklist",
      "tags": ["pre-cycle", "clinic-visit", "testing"],
      "title": "AT YOUR CLINIC",
      "icon": "🏥",
      "body": {
        "items": [
          {
            "id": "afc",
            "label": "Antral follicle count (AFC)",
            "detail": "Combined with AMH, gives the clearest picture of your egg reserve. Done during early cycle.",
            "tags": [
              {
                "label": "Her test",
                "colorKey": "coral"
              },
              {
                "label": "Ultrasound",
                "colorKey": "teal"
              },
              {
                "label": "Clinic only",
                "colorKey": "coral"
              }
            ]
          },
          {
            "id": "consult",
            "label": "RE consultation",
            "detail": "Your reproductive endocrinologist will review everything and create a personalized protocol.",
            "tags": [
              {
                "label": "Both partners",
                "colorKey": "blue"
              },
              {
                "label": "Clinic visit",
                "colorKey": "coral"
              }
            ]
          }
        ]
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
